import type { EconHeaderCountdownEvent } from "../../types/econ-header";
import type { IVScoreResponse } from "../../types/market-data";
import { EconHeaderIvIntro } from "../econ/EconHeaderIvIntro";
import { EconHeaderCountdownPill } from "../econ/EconHeaderCountdownPill";

interface EconCountdownWidgetProps {
  visible: boolean;
  event: EconHeaderCountdownEvent | null;
  ivData?: IVScoreResponse | null;
  ivLoading?: boolean;
  onDismiss: () => void;
}

export function EconCountdownWidget({
  visible,
  event,
  ivData = null,
  ivLoading = false,
  onDismiss,
}: EconCountdownWidgetProps) {
  if (!visible || !event) return null;
  return (
    <EconHeaderCountdownPill
      event={event}
      ivIntro={<EconHeaderIvIntro data={ivData} loading={ivLoading} />}
      onDismiss={onDismiss}
    />
  );
}
